import { Component } from '@angular/core';

@Component({
  selector: 'app-goahead',
  templateUrl: './goahead.component.html',
  styleUrl: './goahead.component.scss'
})
export class GoaheadComponent {

}
